import React, { useEffect, useState } from "react";
import { App, Button, Card, Dropdown, Modal, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdOutlineLocationOn, MdOutlineCategory } from "react-icons/md";
import { HiOutlineChevronDown } from "react-icons/hi";
import AppControl from "../../components";
import { getPincodes, deletePin } from "../../store/slice/pincodes";

function Pincodes() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const { list } = useSelector((state) => state.pincodes);

  useEffect(() => {
    dispatch(getPincodes());
  }, [dispatch]);

  const showDeleteConfirm = (row) => {
    setModalText(`Are you sure you want to delete pincode "${row.pincode}"?`);
    setDeleteId(row.id);
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const resultAction = await dispatch(deletePin(deleteId));
    setOpen(false);
    setConfirmLoading(false);
    if (deletePin.fulfilled.match(resultAction)) {
      message.success(resultAction.payload.message);
      dispatch(getPincodes());
    } else {
      message.error(resultAction.error.message);
    }
  };

  const COLUMNS = [
    { Header: "Id", accessor: "id", isVisible: false, disableFilters: true },
    { Header: "Pincode", accessor: "pincode" },
    { Header: "Name", accessor: "name" },
    { Header: "District", accessor: "district", disableFilters: true },
    { Header: "State", accessor: "state", disableFilters: true },
    { Header: "Branch Type", accessor: "branchType", disableFilters: true },
    {
      Header: "Locality Type",
      accessor: "localityType",
      disableFilters: true,
      Cell: ({ value }) =>
        value ? (
          <Tag color={{ Metro: "red", Urban: "blue", Suburban: "purple", Rural: "green" }[value] ?? "default"}>
            {value}
          </Tag>
        ) : (
          <span className="text-gray-400">—</span>
        ),
    },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "delete",
                danger: true,
                label: (
                  <span onClick={() => showDeleteConfirm(row.values)}>
                    Delete
                  </span>
                ),
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card
      title="PINCODE LIST"
      extra={
        <div className="flex gap-2">
          <AppControl
            control="button"
            type="button"
            name="Assign Locality Type"
            size="md"
            color="indigo"
            icon={<MdOutlineCategory size="1.25em" className="inline mr-1" />}
            onClick={() => navigate("assign")}
          />
          <AppControl
            control="button"
            type="button"
            name="Add Pincode"
            size="md"
            color="orange"
            icon={<MdOutlineLocationOn size="1.25em" className="inline mr-1" />}
            onClick={() => navigate("add")}
          />
        </div>
      }
    >
      <AppControl control="table" columns={COLUMNS} data={list} />
      <Modal
        title="Delete Pincode"
        open={open}
        okText="Yes, Delete!"
        okType="danger"
        onOk={handleOk}
        confirmLoading={confirmLoading}
        cancelText="No, Cancel"
        onCancel={() => setOpen(false)}
      >
        <p>{modalText}</p>
      </Modal>
    </Card>
  );
}

export default Pincodes;
